import { configureStore } from '@reduxjs/toolkit';
import FJSliceImageToImage from './slices/FJSliceImageToImage';
import FJSliceModals from './slices/FJSliceModals';
import FJSliceImageManipulation from './slices/FJSliceImageManipulation';
import FJSliceCommon from './slices/FJSliceCommon';
import FJSliceClothesChanger from './slices/FJSliceClothesChanger';
import FJSliceImageEnhancer from './slices/FJSliceImageEnhancer';
import FJSliceTextToImage from './slices/FJSliceTextToImage';
import FJSliceFaceSwap from './slices/FJSliceFaceSwap';
import FJSliceImageExtender from './slices/FJSliceImageExtender';
import FJSliceFake3d from './slices/FJSliceFake3d';
import FJSliceBrushEditCommon from './slices/FJSliceBrushEditCommon';
import FJSliceObjectErase from './slices/FJSliceObjectErase';
import FJSliceAIVideoGenerator from './slices/FJSliceAIVideoGenerator.js';
import FJSlicePhotoBgRemover from './slices/FJSlicePhotoBgRemover';
import FJSliceAiHistoryCommon from './slices/FJSliceAiHistoryCommon';
import FJSliceImageStroke from './slices/FJSliceImageStroke';
import FJSliceColorCommon from './slices/FJSliceColorCommon';
import FJSliceVideoBgRemover from './slices/FJSliceVideoBgRemover';
import FJSliceGuideModals from './slices/FJSliceGuideModals';
import FJSliceAIAudioGenerator from './slices/FJSliceAIAudioGenerator.js';
import FJSliceRecord from './slices/FJSliceRecord.js';
import FJSliceAiVideoDub from './slices/FJSliceAiVideoDub';
import FJSliceTimeLine from './slices/FJSliceTimeLine.js';
import FJSliceRightTextBaseEditing from './slices/FJSliceRightTextBaseEditing';
import FJTextBasedEditing from './slices/FJTextBasedEditing.jsx';
import FJTextEditFloatingPanel from './slices/FJSliceTextEditFloatingPanel.js';

export default configureStore({
    reducer: {
        modals: FJSliceModals,
        common: FJSliceCommon,
        imageToImage: FJSliceImageToImage,
        imageManipulation: FJSliceImageManipulation,
        imageEnhancer: FJSliceImageEnhancer,
        textToImage: FJSliceTextToImage,
        clothesChanger: FJSliceClothesChanger,
        imageExtender: FJSliceImageExtender,
        faceSwap: FJSliceFaceSwap,
        fake3d: FJSliceFake3d,
        brushEditCommon: FJSliceBrushEditCommon,
        objectErase: FJSliceObjectErase,
        AIVideoGenerator: FJSliceAIVideoGenerator,
        photoBgRemover: FJSlicePhotoBgRemover,
        aiHistoryCommon: FJSliceAiHistoryCommon,
        imageStroke: FJSliceImageStroke,
        colorCommon: FJSliceColorCommon,
        videoBgRemover: FJSliceVideoBgRemover,
        guideModals: FJSliceGuideModals,
        AIAudioGenerator: FJSliceAIAudioGenerator,
        record: FJSliceRecord,
        aiVideoDub: FJSliceAiVideoDub,
        rightTextBaseEditing: FJSliceRightTextBaseEditing,
        timeLine: FJSliceTimeLine,
        textBasedEditing: FJTextBasedEditing,
        textEditFloatingPanel: FJTextEditFloatingPanel,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            //关闭redux序列化检测
            serializableCheck: false,
        }),
});
